import { createReducer, on } from '@ngrx/store';
import { ChatState, initialChatState } from './state';
import { ChatActionTypes, setChatBoxMinimized, setMessages, setChatBoxVisibility } from './actions';

export const chatReducer = createReducer(
  initialChatState,
  on(setChatBoxMinimized, (state, { isMinimized }) => ({
    ...state,
    isChatBoxMinimized: isMinimized
  })),
  on(setMessages, (state, { messages }) => ({
    ...state,
    messages
  })),
  on(setChatBoxVisibility, (state, { showChatBox }) => ({
    ...state,
    showChatBox
  }))
); 